import { AttributesList } from '@app/components/various/AttributesList';
import { Button } from '@app/components/various/Button';
import { CancelSmall } from '@app/components/various/Icons';
import { Skeleton } from '@app/components/various/Skeleton';
import { getProductDetailsAttributes } from '@app/ducks';
import { getDefaultImageAspectRatio } from '@app/ducks/helpers';
import React from 'react';
import { useSelector } from 'react-redux';

import { useProductDetailsLayoutContext } from '../context/ProductDetailsLayoutContext';

import { NavigationArrows } from './NavigationArrows';

interface Props {
  onHideModal: () => void;
}

export const ProductDetailsModalLoader = ({ onHideModal }: Props) => {
  const aspectRatio = useSelector(getDefaultImageAspectRatio);
  const productAttributes = useSelector(getProductDetailsAttributes);

  const { isDesktop, isTablet } = useProductDetailsLayoutContext();

  const attributesSkeletonRows = React.useMemo(() => {
    if (productAttributes.length === 0) {
      return 0;
    }

    if (productAttributes.length <= 3) {
      return 3;
    }

    return 6;
  }, [productAttributes.length]);

  return (
    <div className="mx-auto h-full w-full max-w-[1920px] lg:flex">
      <div
        className="max-h-[calc(100%-84px)] w-full shrink-0 sm:max-h-[calc(100%-170px)] lg:max-h-full lg:w-auto lg:max-w-[50%]"
        style={{ aspectRatio: `${isTablet ? 2 : 1} / ${aspectRatio}` }}
      >
        <Skeleton type="rectangle" className="h-full w-full" />
      </div>
      <div className="flex w-full flex-col gap-8 overflow-hidden bg-white px-4 py-6 lg:p-8 lg:pb-24">
        <div className="flex justify-between">
          <div className="flex w-full flex-col gap-1">
            <Skeleton type="text" size={isDesktop ? 'xxlarge' : 'xlarge'} width={75} />
            <Skeleton type="text" size="medium" width={35} />
          </div>
          <div className="hidden gap-5 sm:flex">
            <NavigationArrows />
            <Button icon={CancelSmall} aria-label="Close modal" color="secondary" variant="flat" onClick={onHideModal} />
          </div>
        </div>
        <AttributesList attributes={[]} isLoading skeletonRows={attributesSkeletonRows} />
        <div className="w-64">
          <Skeleton type="button" size="large" />
        </div>
        <div className="flex flex-col gap-6">
          <Skeleton type="rectangle" className="h-60 w-full" />
          <Skeleton type="rectangle" className="h-60 w-full" />
        </div>
      </div>
    </div>
  );
};
